var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import _ from 'lodash';
import { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { apiDeleteDocumentFavoriteMany, apiGetListDocumentFavorite, } from '../../../../actions/FavoriteActions';
import { propFunc } from '../../../../helpers/custom-prop-types';
import SubmitButton from '../../../Ui/Button/SubmitButton';
import { CurrentProcessLoader } from '../../../Ui/Loading';
import MyFavoriteDocumentCardList from './MyFavoriteDocumentCardList';
class MyFavoriteDocument extends Component {
    constructor(props) {
        super(props);
        this.updateState = (state) => {
            if (!this.unmount) {
                this.setState(state);
            }
        };
        this.onChange = (e) => {
            const { checked, value } = e.currentTarget;
            const { checks } = this.state;
            const id = parseInt(value, 10);
            if (checked) {
                this.setState({
                    checks: [...checks, id],
                });
            }
            else {
                this.setState({
                    checks: checks.filter((v) => v !== id),
                });
            }
        };
        this.onClickDelete = () => __awaiter(this, void 0, void 0, function* () {
            const { deleteFavorites } = this.props;
            const { checks, list } = this.state;
            try {
                this.updateState({
                    checks: [],
                    list: list.filter((v) => !checks.includes(v.id)),
                });
                yield deleteFavorites(checks);
            }
            finally {
                this.updateState({ isDeleting: false });
            }
        });
        this.onClickMore = () => __awaiter(this, void 0, void 0, function* () {
            const { getLessThanFavorites } = this.props;
            const { list } = this.state;
            this.updateState({ isMoreLoading: true });
            try {
                const { id } = list[list.length - 1];
                const res = yield getLessThanFavorites(id);
                const { payload: { list: getList }, total, } = res;
                const updateList = _.uniqBy([...list, ...getList], (row) => row.id);
                this.updateState({
                    isHasMore: total > updateList.length,
                    list: updateList,
                });
            }
            finally {
                this.updateState({ isMoreLoading: false });
            }
        });
        this.state = {
            checks: [],
            isDeleting: false,
            isHasMore: false,
            isLoading: false,
            isMoreLoading: false,
            list: [],
        };
        this.unmount = false;
    }
    componentDidMount() {
        const { getFavorites } = this.props;
        this.updateState({ isLoading: true });
        getFavorites()
            .then((res) => {
            const { payload: { list }, total, } = res;
            this.updateState({
                isHasMore: total > list.length,
                list,
            });
        })
            .finally(() => {
            this.updateState({ isLoading: false });
        });
    }
    componentWillUnmount() {
        this.unmount = true;
    }
    render() {
        const { checks, isDeleting, isHasMore, isLoading, isMoreLoading, list } = this.state;
        return (_jsx("div", Object.assign({ className: 'l-container-12' }, { children: _jsxs("div", Object.assign({ className: 'content-box' }, { children: [_jsx("h3", { children: "\u304A\u6C17\u306B\u5165\u308A\u8CC7\u6599" }), _jsx("div", Object.assign({ className: 'favorite-select' }, { children: _jsx("div", Object.assign({ className: 'favorite-select-inner' }, { children: _jsx(SubmitButton, { buttonType: 'button', className: 'link-text select-delete', isDisabled: isDeleting || checks.length === 0, isLoading: isDeleting, onClick: this.onClickDelete, text: _jsxs(_Fragment, { children: [_jsx("i", Object.assign({ className: 'material-icons hov-icon md-18' }, { children: "delete" })), "\u304A\u6C17\u306B\u5165\u308A\u304B\u3089\u524A\u9664"] }) }) })) })), _jsx("div", Object.assign({ className: 'l-favorite-document is-flex' }, { children: isLoading ? (_jsx(CurrentProcessLoader, { marginTop: 30 })) : (_jsx(MyFavoriteDocumentCardList, { list: list, onChange: this.onChange })) })), isHasMore && (_jsx("div", Object.assign({ className: 'align-center l-bottom mt2' }, { children: _jsx(SubmitButton, { isDisabled: isMoreLoading, isLoading: isMoreLoading, onClick: this.onClickMore, text: 'View More' }) })))] })) })));
    }
}
MyFavoriteDocument.propTypes = {
    deleteFavorites: propFunc().isRequired,
    getFavorites: propFunc().isRequired,
    getLessThanFavorites: propFunc().isRequired,
};
const mapDispatchToProps = (dispatch) => ({
    deleteFavorites: (ids) => new Promise((resolve, reject) => {
        dispatch(apiDeleteDocumentFavoriteMany(ids, { reject, resolve }));
    }),
    getFavorites: () => new Promise((resolve, reject) => {
        dispatch(apiGetListDocumentFavorite({}, { reject, resolve }));
    }),
    getLessThanFavorites: (lastId) => new Promise((resolve, reject) => {
        dispatch(apiGetListDocumentFavorite({ less_than: lastId }, { reject, resolve }));
    }),
});
const enhance = compose(connect(null, mapDispatchToProps));
export default enhance(MyFavoriteDocument);
